import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useMatches,
} from 'react-router';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let matches = useMatches();

    return (
      <Component {...props} router={{ location, navigate, params, matches }} />
    );
  }

  return ComponentWithRouterProp;
}
